// Migrated from transition-web/src/components/SignedInGoToDashboard.tsx
// Updated to use new design system

import { useNavigate } from 'react-router-dom'
// import { useTranslation } from '../shared/hooks/useIntractionTranslate' // TODO: Re-enable when translations are added
import { isParticipantRole } from '../features/organization/orgStateHelpers'
import { SignedInViewProps } from '../types/SignedInTypes'
import { BackgroundBox, Button, InnerBox } from '../interaxDesignSystemComponents'
import { useLogout } from '../hooks/useLogout'
import useAppState from '../hooks/useAppState'

export default function SignedInGoToDashboard({ isLoading, signedInState }: SignedInViewProps) {
  // const { t } = useTranslation() // TODO: Add translations when needed
  const navigate = useNavigate()
  const { state } = useAppState()
  const logout = useLogout(() => navigate('/'))

  const handleGoToDashboard = () => {
    if (isParticipantRole(state.user)) {
      navigate('/gamer')
      return
    }
    navigate('/facilitator')
  }

  return (
    <div className="min-h-screen bg-off-black flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        <BackgroundBox>
          <div className="flex justify-between items-center mb-8">
            <div></div>
            <Button variant="link" onClick={logout} className="text-thunder-grey hover:text-white">
              Sign Out
            </Button>
          </div>

          <InnerBox>
            {/* Header */}
            <div className="text-center">
              <div className="mb-8">
                {/* Success Icon */}
                <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h1 className="text-3xl font-semibold text-white mb-2">Welcome to Interax!</h1>
              <p className="text-thunder-grey">You're all set up and ready to start collaborating with your team.</p>
            </div>

            {/* Team Info */}
            {signedInState.data.team && (
              <div className="bg-heritage-blue/10 border border-heritage-blue/20 rounded-lg p-6">
                <h2 className="text-xl font-semibold text-white mb-2">Your Team</h2>
                <p className="text-thunder-grey mb-2">
                  <strong>Team Name:</strong> {signedInState.data.team.name}
                </p>
                <p className="text-thunder-grey">
                  <strong>Team Code:</strong> {signedInState.data.team.code}
                </p>
              </div>
            )}

            {/* Go to Dashboard Button */}
            <Button variant="primary" fullWidth onClick={handleGoToDashboard} disabled={isLoading} className="h-12">
              {isLoading ? 'Loading...' : 'Go to Dashboard'}
            </Button>
          </InnerBox>
        </BackgroundBox>
      </div>
    </div>
  )
}
